// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Ljtg","label":"styles_label__1G-D8","input":"styles_input__g4wI_"};